import axios from "axios";

const API_URL =
  import.meta.env.VITE_API_BASE_URL || "https://thalvora-exports.onrender.com";

// ✅ BASE URL (for images)
const BASE_URL = API_URL

export interface Product {
  id: string;
  name: string;
  slug: string;
  category: {
    id: string;
    name: string;
    slug: string;
  };
  images: string[];
  description: string;
  shortDescription: string;
  origin: string;
  packaging: string[];
  shelfLife: string;
  moq: string;
  exportAvailability: string[];
  qualityInfo: string;
  specifications: Record<string, string>;
  isActive: boolean;
  orderIndex: number;
}

class ProductService {

  // 🔥 normalize image URLs centrally
  private normalizeImages(images: string[] = []) {
    return images.map((url) => {
      if (!url) return "";

      // already full URL
      if (url.startsWith("http")) return url;

      // ensure leading slash
      const normalized = url.startsWith("/") ? url : `/${url}`;

      return `${BASE_URL}${normalized}`;
    });
  }
async getProductBySlug(slug: string): Promise<Product> {
  const res = await axios.get(`${API_URL}/products/public/${slug}`);
  return res.data;
}
  // 🔥 normalize product
  private normalizeProduct(product: any): Product {
    return {
      ...product,
      images: this.normalizeImages(product.images),
    };
  }

  // ✅ GET ALL PRODUCTS (FIXED)
  async getAllProducts(): Promise<Product[]> {
    const res = await axios.get(`${API_URL}/products/public`);

    const data = res.data || [];

    // 🔥 normalize all products
    return data.map((p: any) => this.normalizeProduct(p));
  }

  // ✅ CREATE PRODUCT
  async createProduct(data: any) {
    const token = localStorage.getItem("token");

    return axios.post(`${API_URL}/products/admin`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
  }
}


export const productService = new ProductService();